import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth'
import bry from './modules/bry'
import file from './modules/file'
import lote from './modules/lote'
import procedimento from './modules/procedimento'
import recovery from './modules/recovery'
import repositorio from './modules/repositorio'
import search from './modules/search'
import webSockets from './modules/webSockets'
import window from './modules/window'
import papeisSeguranca from './modules/papeisSeguranca'
import custa from './modules/custa'
import statusDosSelos from './modules/statusDosSelos'
import releasesNotes from './modules/releasesNotes'
import impressaoReciboOS from './modules/impressaoReciboOS'
import eProtocolo from './modules/eProtocolo'

Vue.use(Vuex)
Vue.config.devtools = true


import frenteCaixa from './modules/frenteCaixa'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    bry,
    file,
    lote,
    procedimento,
    recovery,
    repositorio,
    search,
    webSockets,
    window,
    papeisSeguranca,
    custa,
    frenteCaixa,
    statusDosSelos,
    releasesNotes,
    impressaoReciboOS,
    eProtocolo
  },
  plugins: [
    createPersistedState({
      key: 'SofiaStrore',
      paths: [
        'auth',
        'bry',
        'file',
        'lote',
        'procedimento',
        'recovery',
        'repositorio',
        'search',
        'webSockets',
        'window',
        'releasesNotes',
        'impressaoReciboOS',
        'eProtocolo'
      ]
    })
  ]
})
